import { useState } from 'react';
import { Table, Row, Col } from 'react-bootstrap';

// Components
import Button from '~/components/CustomButton/CustomButton.jsx';
import Delete from '~/assets/img/deleting.svg';

// Elements
import { Input } from '~/elements/Input';

const VARIABLE_KEY_RE = /^[a-z][a-z0-9_]*$/;

const VariablesTab = ({ t, variables, onChange }) => {
    const [draft, setDraft] = useState({ key: '', label: '', example: '' });
    const [error, setError] = useState('');

    const handleAdd = () => {
        const key = draft.key.trim();
        const label = draft.label.trim();
        const example = draft.example.trim();

        const validations = [
            { invalid: !key || !VARIABLE_KEY_RE.test(key), message: t('Variable key must start with a letter and contain only lowercase letters, numbers, and underscores.') },
            { invalid: !label, message: t('Label is required.') },
            { invalid: !example, message: t('Example is required.') },
            { invalid: variables.some((v) => v.key === key), message: t('A variable key with this name already exists.') },
        ];
        const failed = validations.find((v) => v.invalid);
        if (failed) {
            setError(failed.message);
            return;
        }

        setError('');
        onChange([...variables, { key, label, example }]);
        setDraft({ key: '', label: '', example: '' });
    };

    const handleRemove = (key) => onChange(variables.filter((v) => v.key !== key));

    return (
        <div>
            <small className="text-muted d-block mb-3">
                <strong>{t('Note')}**</strong>{' '}
                {t('Make sure the variable key matches the variable name used in the notification code. New variables will be available in messages after you save.')}
            </small>
            <Row className="g-2 mb-3">
                <Col md={6}>
                    <Input label={t('Key')} value={draft.key}
                        onChange={(e) => setDraft((prev) => ({ ...prev, key: e.target.value.toLowerCase().replace(/[^a-z0-9_]/g, '_') }))}
                        placeholder="e.g. employee_name" />
                </Col>
                <Col md={6}>
                    <Input label={t('Label')} value={draft.label}
                        onChange={(e) => setDraft((prev) => ({ ...prev, label: e.target.value }))}
                        placeholder="e.g. Employee Name" />
                </Col>
            </Row>
            <Row className="g-2 align-items-end">
                <Col md={6}>
                    <Input label={t('Example')} value={draft.example}
                        onChange={(e) => setDraft((prev) => ({ ...prev, example: e.target.value }))}
                        placeholder="e.g. John Doe" />
                </Col>
                <Col md={6}>
                    <Button fill onClick={handleAdd} disabled={!draft.key.trim()}>{t('Add')}</Button>
                </Col>
            </Row>
            {error && <small className="text-danger d-block mt-2">{error}</small>}

            {variables.length > 0 && (
                <Table className="table-sm mt-3">
                    <thead>
                        <tr>
                            <th>{t('Key')}</th>
                            <th>{t('Label')}</th>
                            <th>{t('Example')}</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {variables.map((v) => (
                            <tr key={v.key}>
                                <td><code>{`{{${v.key}}}`}</code></td>
                                <td>{v.label}</td>
                                <td>{v.example}</td>
                                <td className="text-center">
                                    <Button icon_sm_delete fill onClick={() => handleRemove(v.key)}>
                                        <img src={Delete} alt="delete" />
                                    </Button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            )}
        </div>
    );
};

export default VariablesTab;
